import { IProcessState } from './iprocess-state';
import { IGenericState } from './igeneric-state';
import { ITenantState } from './itenant-state';
import { IRouterState } from './irouter-state';
export interface IAppState {
    process: IProcessState;
    generic: IGenericState;
    tenant: ITenantState;
    router: IRouterState;
}